module.exports = __webpack_public_path__ + "static/img/homeright11.39bbce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeright11.png
// module id = jMzV
// module chunks = 13